import { Id } from '../types/Id';
import { authenticatedInstance } from './axiosInstance';

export const getNotUsedMemberships = async (companyId: Id) => {
  return authenticatedInstance.get(
    `/memberships/notUsed?company_id=${companyId}`
  );
};

export const getAllMemberships = async () => {
  return authenticatedInstance.get(`/memberships`);
};
